import { render, staticRenderFns } from "./confirmCloseAndRefuseDialog.vue?vue&type=template&id=6dc65596&"
import script from "./confirmCloseAndRefuseDialog.vue?vue&type=script&lang=ts&"
export * from "./confirmCloseAndRefuseDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports